import { useState } from 'react';

const CopyButton = ({ text, className = '', children, onCopy }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      if (!text) {
        setCopied(false);
        onCopy?.(false);
        return;
      }
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      setCopied(true);
      onCopy?.(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (error) {
      console.error('Copy failed', error);
      setCopied(false);
      onCopy?.(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={className || 'rounded-md border border-slate-300 px-3 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-100'}
    >
      {copied ? 'Copiado' : children || 'Copiar'}
    </button>
  );
};

export default CopyButton;
